import store from '../front/store';
import Vue from 'vue';

const title = process.env.MIX_TITLE;
const trans = Vue.prototype.trans;

export default [
  {
    path: '/more-settings/report-center',
    name: 'ticket-center',
    component: () => import('./views/pages/MoreSettings/TicketCenter'),
    meta: {
      layout: 'MoreSettingsLayout',
      title: title + ' | ' + trans.get('ms:report_center.title'),
      profile: false,
    },
  },
  {
    path: '/more-settings/security-center',
    name: 'security-center',
    component: () => import('./views/pages/MoreSettings/SecurityCenter'),
    meta: {
      layout: 'MoreSettingsLayout',
      title: title + ' | ' + trans.get('ms:security_center.title'),
      profile: false,
    },
  },
  {
    path: '/unsubscribe-email/:token?',
    name: 'unsubscribe-email',
    component: () => import('./views/pages/UnsubscribeEmail.vue'),
    meta: {
      layout: 'DefaultLayout',
      title: title,
      profile: false,
    },
  },
  {
    path: '/mobile/payment',
    component: () => import('./views/pages/RouterView.vue'),
    children: [
      {
        path: '/',
        name: 'mobile-payment-v4',
        component: () => import('./views/pages/Mobile/PaymentV4.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('shop/setSelectedPackage', null);

          if (to.hash !== '#b') {
            store.commit('shop/setVoucher', null);
          }

          return next();
        },
      },
      {
        path: ':packageId',
        name: 'mobile-payment-method-v4',
        component: () => import('./views/pages/Mobile/PaymentV4.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('shop/setSelectedPackage', null);

          return next();
        },
      },
    ],
    beforeEnter(to, from, next) {
      store.commit('settings/setIsMobile', true);
      return next();
    },
  },
  {
    path: '/mobile/payment-v4',
    component: () => import('./views/pages/RouterView.vue'),
    children: [
      {
        path: '/',
        name: 'mobile-payment-v4',
        component: () => import('./views/pages/Mobile/PaymentV4.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('shop/setSelectedPackage', null);

          if (to.hash !== '#b') {
            store.commit('shop/setVoucher', null);
          }

          return next();
        },
      },
      {
        path: ':packageId',
        name: 'mobile-payment-method-v4',
        component: () => import('./views/pages/Mobile/PaymentV4.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('shop/setSelectedPackage', null);

          return next();
        },
      },
    ],
    beforeEnter(to, from, next) {
      store.commit('settings/setIsMobile', true);
      return next();
    },
  },
  {
    path: '/mobile/payment-v2',
    component: () => import('./views/pages/RouterView.vue'),
    children: [
      {
        path: '/mobile/payment-v2',
        name: 'mobile-payment-v2',
        component: () => import('./views/pages/Mobile/PaymentV2.vue'),
        meta: {
          layout: 'MobileLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('settings/setIsMobile', true);
          store.commit('shop/setSelectedPackage', null);

          if (to.hash !== '#b') {
            store.commit('shop/setVoucher', null);
          }

          return next();
        },
      },
      {
        path: ':packageId',
        name: 'mobile-payment-package-v2',
        component: () => import('./views/pages/Mobile/PaymentV2.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('settings/setIsMobile', true);

          if (to.hash !== '#b') {
            store.commit('shop/setVoucher', null);
          }

          return next();
        },
      },
      {
        path: ':unit/:packageId',
        name: 'mobile-payment-method-v2',
        component: () => import('./views/pages/Mobile/PaymentV2.vue'),
        meta: {
          layout: 'DefaultLayout',
          title: title,
          profile: false,
        },
      },
    ],
    beforeEnter(to, from, next) {
      store.commit('settings/setIsMobile', true);
      return next();
    },
  },
  {
    path: '/mobile/payment-old',
    component: () => import('./views/pages/RouterView.vue'),
    children: [
      {
        path: '/',
        name: 'mobile-payment-old',
        component: () => import('./views/pages/Mobile/PaymentV1'),
        meta: {
          layout: 'MobileLayout',
          title: title,
          profile: false,
        },
        beforeEnter(to, from, next) {
          store.commit('settings/setIsMobile', true);

          next();
          return true;
        },
      },
      {
        path: '/more-settings/payment-old/:unit',
        name: 'payment-old',
        component: () => import('#js_site/views/pages/MoreSettings/PaymentV1'),
        meta: {
          layout: 'MoreSettingsLayout',
          title: title,
          profile: false,
        }
      },
    ],
  },
  {
    path: '/old',
    component: () => import('./views/pages/RouterView.vue'),
    children: [
      {
        path: '/old/restore-account/:hash',
        name: 'old-restore-account',
        component: () => import('#js_site/views/pages/RestoreAccount.vue'),
        meta: {
          layout: 'HomeLayout',
          title: title + ' | ' + trans.get('pages:restore_account.title'),
          profile: false,
        }
      },
    ],
  },
];
